import { ApiClient } from "#/shared/api/client";
import { Status } from "#ce/apps/SpInsuranceApp/models/status";

export class StatusApi extends ApiClient {
  constructor() {
    super({ api: "insurance_plan", model: Status });
  }

  async get(url, insurancePlanId) {
    const query = {};
    if (insurancePlanId) {
      query.insurance_plan = insurancePlanId;
    }
    return super.get(url, query);
  }
}

let instance;

export const createStatusApi = (url) => {
  instance ??= new StatusApi();

  return {
    status: async (insurancePlanId) => instance.get(url, insurancePlanId),
  };
};
